export const IS_PRIVATE_PLATFORM = true;

export const MUIX_LICENSE: string =
	'54a4252841156bdbe84690be74bcf99dTz0xMTI0OTYsRT0xNzc4MTExOTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y';

export const ERROR_MESSAGE = {
	// Login
	'Invalid identifier or password': 'Benutzername oder E-Mail Adresse oder Passwort ist falsch.',
	'Your account email is not confirmed': 'Ihr Konto ist noch nicht aktiv.',
	'Your account has been blocked by an administrator': 'Ihr Benutzerkonto wurde gesperrt.',
	// Send E-Mail Confirmation
	'already.confirmed': 'Ihre E-Mail-Adresse wurde schon einmal bestätigt. Sie brauchen nicht nochmal zu bestätigen.',
	'token.invalid': 'Ungültiger Schlüssel.',
	// Forgot-Password
	'This email does not exist': 'Die von Ihnen eingegebene E-Mail-Adresse existiert nicht.',
	'This user is disabled': 'Ihr Benutzerkonto ist deaktiviert.',
	'Incorrect code provided': 'Ungültiger Schlüssel.',
	'Passwords do not match': 'Beide Passwörter stimmen nicht überein.',
	'Incorrect params provided': 'Beide Passwörter stimmen nicht überein.',
	'The provided current password is invalid': 'Ihr altes Password ist falsch.',
	'Your new password must be different than your current password': 'Ihr neues Passwort muss sich von Ihrem aktuellen Passwort unterscheiden.',
	'User not found': 'Der Benutzername existiert nicht. Bitte überprüfen Sie Ihre Eingabe.',
};

export const ABSCHLUSS_SEITE_HEADEING_DESCRIPTION =
	'Überprüfen Sie noch einmal die wichtigsten Daten und folgen dann Schritten weiter unten um den Antrag einzureichen';

export const HINWEIS_AN_HA_PLACEHOLDER_TEXT = 'Fassen Sie in wenigen Worten zusammen, welche Änderungen Sie an der Skizze vorgenommen haben.';
export const PLATZHALTER_TEXT = '';
export const ALS_ERLEDIGT_MARKIEREN_LABEL = 'Als erledigt markieren';
export const UEBERARBEITUNGS_HINWEIS_TITLE = 'Überarbeitungshinweis';
export const ERLAUTERUNG_IN_KOSTEN_TITLE = 'Erläuterungen';
export const NOCH_NICHT_MOEGLICH_TEXT = 'Noch nicht möglich';
export const MITTEL_ABRUF_ZUERST_ERSTELLEN_TEXT = 'Sie müssen ein Mittelabruf zuerst erstellen';
export const ABSCHLUSS_DESCRIPTION =
	'Überprüfen Sie noch einmal die wichtigsten Daten und folgen dann Schritten weiter unten um den Antrag einzureichen';
export const ANGABEN_IN_NETTO = 'Alle Angaben sind in Netto';
export const ANGABEN_IN_BRUTTO = 'Alle Angaben sind in Brutto';

export const PROGRAMM_MAX_ERLAUBT_TEXT = 'Es sind maximal 5 Programme erlaubt.';
export const EINZELPOSITION_MAX_ERLAUBT_TEXT = 'Es sind maximal 50 Einzelposition erlaubt.';

export const FORM_FIELDS_TYPES = {
	label: 'label',
	string: 'string',
	text: 'text',
	textEditor: 'textEditor',
	richtext: 'richtext',
	markdownEditor: 'markdownEditor',
	integer: 'integer',
	decimal: 'decimal',
	enumeration: 'enumeration',
	singleSelect: 'singleSelect',
	autocomplete: 'autocomplete',
	singleUpload: 'singleUpload',
	media: 'media',
	componentMedia: 'componentMedia',
	datetime: 'datetime',
	date: 'date',
	checkbox: 'checkbox',
	boolean: 'boolean',
	radio: 'radio',
	// component: 'component',
	componentTable: 'componentTable',
	editableTable: 'editableTable',
	multiSelect: 'multiSelect',
	divider: 'divider',
	infoBox: 'infoBox',
	nothing: 'nothing',
} as const;

export const MONAT_LISTE = [
	{ Monat: 'Januar' },
	{ Monat: 'Februar' },
	{ Monat: 'Maerz' },
	{ Monat: 'April' },
	{ Monat: 'Mai' },
	{ Monat: 'Juni' },
	{ Monat: 'Juli' },
	{ Monat: 'August' },
	{ Monat: 'September' },
	{ Monat: 'Oktober' },
	{ Monat: 'November' },
	{ Monat: 'Dezember' },
];

export const ERLAUTERUNG_DEFAULT_COLUMNS_LABEL = ['Liegt bei', 'Entfällt', 'Erläuterung zur Anlage'];

export const FILE_UPLOAD_ALLOWED_SIZE = 10485760; // 10MB
export const FILE_UPLOAD_ALLOWED_FORMATS = [
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	'application/pdf',
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	'image/jpeg',
	'image/bmp',
	'image/png',
];
export const FILE_UPLOAD_ALLOWED_FORMATS_ONLY_IMAGES = ['image/jpeg', 'image/bmp', 'image/png'];
export const INVALID_FILE_UPLOAD_TEXT_MESSAGE =
	'Zulässige Dateiformate sind: .docx, .pdf, .xlsx, .png, .bmp oder .jpeg. Ältere Formate sind wie .doc oder .xls werden nicht akzeptiert.';
export const INVALID_ONLY_IMAGES_UPLOAD_TEXT_MESSAGE = 'Zulässige Dateiformate sind: .png, .bmp oder .jpeg. Andere Formate  werden nicht akzeptiert.';

export const MAX_TEXTBOX_LENGTH = 2500;
export const MAX_TEXTFIELD_LENGTH = 255;

export const NOT_FOUND_ERROR_MESSAGE = 'Etwas ist schief gelaufen.';

export const NACHRICHT_ORDNER = {
	Posteingang: 'Posteingang',
	Postausgang: 'Postausgang',
	entwurf: 'Entwuerfe',
};

export const MEDIAN_INTERVAL = {
	jaehrlich: 1,
	halbjaehrlich: 2,
	quartalisch: 3,
};

export const UNTERNEHMENS_ROLLE = {
	MusikSchule: 'Musik45UndKunstschule',
	Kommune: 'Kommune47Landkreis',
	Grundschlue: 'Grundschule',
};

export const ANTRAGS_STATUS = {
	inBearbeitung: 'InBearbeitung',
	inPruefung: 'InPruefung',
	bewilligt: 'Bewilligt',
	Abgelehnt: 'Abgelehnt',
	ZuwendungsvertragErstellt: 'ZuwendungsvertragErstellt',
	ZuwendungsvertragUnterzeichnet: 'ZuwendungsvertragUnterzeichnet',
	InFoerderung: 'InFoerderung',
	Abgeschlossen: 'Abgeschlossen',
	inUeberarbeitungDurchAntragssteller: 'InUeberarbeitung',
	vertragUebermittel: 'ZuwendungsvertragUebermittelt',

	// Alte Status
	// Soll wahrscheinlich gelöscht werden
	eingegangen: 'eingegangen',
	// inPruefung: 'inPruefung',
	vollstaendigKorrekt: 'vollstaendig47Korrekt',
	unvollstaendigInkorrekt: 'unvollstaendig47Inkorrekt',

	fuerGremiumFreigegeben: 'fuerGremiumFreigegeben',
	EmpfehlungZurUeberarbeitung: 'EmpfehlungZurUeberarbeitung',
	EmpfehlungZurAblehnung: 'EmpfehlungZurAblehnung',
	EmpfehlungZurAntragstellung: 'EmpfehlungZurAntragstellung',
	EmpfehlungZurFoerderung: 'EmpfehlungZurFoerderung',
	abgelehnt: 'abgelehnt',
	GutachtenAngefordert: 'GutachtenAngefordert',
	GutachtenErfolgt: 'GutachtenErfolgt',
	FinalisierungDurchAntragssteller: 'FinalisierungDurchAntragssteller',
	eingegangenNachFinalisierung: 'eingegangenNachFinalisierung',
	imUnterschriftenlauf: 'imUnterschriftenlauf',
	FoerderbescheidErstellt: 'FoerderbescheidErstellt',
	FoerderbescheidUebermittelt: 'FoerderbescheidUebermittelt',
	FoerderbescheidHatBestandskraft: 'FoerderbescheidHatBestandskraft',
	demProgrammleiterVorgelegt: 'demProgrammleiterVorgelegt',
	demControllingVorgelegt: 'demControllingVorgelegt',
	demMinisteriumVorgelegt: 'demMinisteriumVorgelegt',
	ProjektBeendet: 'ProjektBeendet',
	ProjektBeendet45ZweckbindungsfristLaeuft: 'ProjektBeendet45ZweckbindungsfristLaeuft',
	AntragDurchAenderungsantragAbgeloest: 'AntragDurchAenderungsantragAbgeloest',
	EntscheidungsvorlageErstellt: 'EntscheidungsvorlageErstellt',
	ControllingErfolgt: 'ControllingErfolgt',
	FoerderbescheidVorbereitet: 'FoerderbescheidVorbereitet',
	FoerderbescheidImUnterschriftenlauf: 'FoerderbescheidImUnterschriftenlauf',
	AntragstellungErlauben: 'AntragstellungErlauben',
	AufStellungnahme47GutachtenVerzichtet: 'AufStellungnahme47GutachtenVerzichtet',
	freigegeben: 'akzeptiert',
};
export const VN_STATUS = {
	InBearbeitung: 'InBearbeitung',
	InPruefung: 'InPruefung',
	Bewilligt: 'Bewilligt',
	Abgelehnt: 'Abgelehnt',
	ZuwendungsvertragErstellt: 'ZuwendungsvertragErstellt',
	ZuwendungsvertragUebermittelt: 'ZuwendungsvertragUebermittelt',
	ZuwendungsvertragUnterzeichnet: 'ZuwendungsvertragUnterzeichnet',
	InFoerderung: 'InFoerderung',
	InUeberarbeitung: 'InUeberarbeitung',
	freigegeben: 'freigegeben',
	Abgeschlossen: 'Abgeschlossen',
	PruefmitteilungUebermittelt: 'PruefmitteilungUebermittelt',
};

export const APP_STATUS_EDITABLE = [ANTRAGS_STATUS.inBearbeitung, ANTRAGS_STATUS.inUeberarbeitungDurchAntragssteller];
export const APP_STATUS_EDITABLE_VN = [VN_STATUS.InBearbeitung, VN_STATUS.PruefmitteilungUebermittelt, VN_STATUS.InUeberarbeitung];
export const BEWILLIGTE_SPALTE_ANZEIGEN = [
	ANTRAGS_STATUS.vertragUebermittel,
	ANTRAGS_STATUS.ZuwendungsvertragUnterzeichnet,
	ANTRAGS_STATUS.InFoerderung,
	ANTRAGS_STATUS.Abgeschlossen,
];

export const ANTRAG_TYP = {
	Antrag: 'Antrag',
	Skizze: 'Skizze',
	Verwendungsnachweis: 'Verwendungsnachweis',
	Zwischenmeldung: 'Zwischenmeldung',
};

export const KOSTENTRAEGER = {
	Antragsteller: 'Antragsteller',
	Verbundpartner: 'Verbundpartner',
};
export const VORHABENS_ART = {
	Einzelvorhaben: 'Einzelvorhaben',
	Verbundvorhaben: 'Verbundvorhaben',
};
export const ANTRAGS_FORMULAREN = {
	EmobInvest: 'Elektromobilitaet40Investitionsvorhaben41',
	EmobFundE: 'Elektromobilitaet40Forschungs45UndEntwicklungsvorhaben41',
	Loewe: 'LOEWE45Foerderlinie3',
	Elektrobusse: 'Elektrobusse',
	LogistikUndMobilitaet: 'LogistikUndMobilitaet',
	Mobilitaetsplaene: 'Mobilitaetsplaene',
	StartUpStipendium: 'Start45up45Stipendium',
	StartUpProjekte: 'Start45up45Projekte',
	Kreativwirtschaft: 'Kreativwirtschaft',
	Messefoerderung: 'Messefoerderung',
	Entwicklungszusammenarbeit: 'Entwicklungszusammenarbeit',
};

export const KOSTEN_POSITION = {
	Ausgabe: 'Ausgabe',
	Einnahme: 'Einnahme',
};

export const KOSTEN_ARTEN = {
	Personalkosten: 'Personalkosten',
	Sachkosten: 'Sachkosten',
};
export const PRUEF_ASSISTENZ_STATUS = {
	ungeprüft: 'ungeprueft',
	uberarbeitung: 'zurUeberarbeitung',
	freigegeben: 'freigegeben',
};

export const TEMPLATES = {
	[ANTRAGS_FORMULAREN.EmobInvest]: 3,
	[ANTRAGS_FORMULAREN.EmobFundE]: 1,
	[ANTRAGS_FORMULAREN.Messefoerderung]: 5,
};

export const TEMPLATES_MA = {
	[ANTRAGS_FORMULAREN.EmobInvest]: 7,
	[ANTRAGS_FORMULAREN.EmobFundE]: 7,
	[ANTRAGS_FORMULAREN.Messefoerderung]: 7,
};
export const TEMPLATES_VN = {
	[ANTRAGS_FORMULAREN.EmobInvest]: 99,
	[ANTRAGS_FORMULAREN.EmobFundE]: 99,
	[ANTRAGS_FORMULAREN.Messefoerderung]: 99,
};
export const TEMPLATES_ZN = {
	[ANTRAGS_FORMULAREN.EmobInvest]: 99,
	[ANTRAGS_FORMULAREN.EmobFundE]: 99,
	[ANTRAGS_FORMULAREN.Messefoerderung]: 99,
};
export const TEMPLATES_AB = {
	[ANTRAGS_FORMULAREN.EmobInvest]: 99,
	[ANTRAGS_FORMULAREN.EmobFundE]: 99,
	[ANTRAGS_FORMULAREN.Messefoerderung]: 99,
};

export const IN_BEANTRAGTE_VORHABEN = {
	ausschliesslich: 'ausschliesslich',
	nurTeilweise: 'nurTeilweise',
};

export const ANTRAG_HALBJAHR_ART = {
	ersteHalbJahr: 'erstesHalbjahr',
	zweiteHalbJahr: 'zweitesHalbjahr',
};

export const NACHWEIS_BUTTON_SICHTBAR = [ANTRAGS_STATUS.InFoerderung];

export const SACHKOSTEN_DEFAULT_AMOUNT = 500;

export const MAX_COLUMNS_HORIZONTAL_LAYOUT = 9;
